export default {
  errors: {
    requiredField: 'Поле обязательно для заполнения',
    positiveNumber: 'Укажите положительное число',
    positiveIntegerNumber: 'Укажите положительное целое число',
    invalidEmail: 'Введен не валидный Email',
    invalidUrl:
      'Некорректный url. Пример валидного url: https://example.com/path/',
    somethingWentWrong:
      'Произошла непредвиденная ошибка. Пожалуйста, обратитесь в службу технической поддержки.',
  },
}
